import { useState, useRef } from "react";
import { ReactComponent as SnakePlusIcon } from "./../../../../assets/images/icon/snake-plus.svg";
import SnakeOne from "./../../../../assets/images/picture/snake_one.png";
import SnakeTwo from "./../../../../assets/images/picture/snake_two.png";
import SnakeThree from "./../../../../assets/images/picture/snake_three.png";
import Snake from "./../../../../assets/images/picture/snake_image.png";
import Modal from "react-bootstrap/Modal";
import { ReactComponent as CloseModalIcon } from "./../../../../assets/images/icon/delete.svg";
import { ReactComponent as ArrowDown } from "./../../../../assets/images/icon/arrow-down.svg";
import ViewHeightFull from "./../../../common/viewHeightFull";
import { toast } from "react-toastify";
import Collapse from "react-bootstrap/Collapse";
import CustomGoogleMap from "./googleMap";
function UploadImageStep(props) {
  const [uploadSate, setUploadState] = useState("beforeUpload");
  const [hasInformation, setHasInformation] = useState(false);
  const [uploadDetailsModal, setUploadDetailsModal] = useState(false);
  const [locationCollapse, setLocationCollapse] = useState(true);
  const [sizeCollapse, setSizeCollapse] = useState(true);
  const [snakeFace, setSnakeFace] = useState(null);
  const [userLocation, setUserLocation] = useState({
    lat: 31.318327,
    lng: 48.67062,
  });
  const [detailModel, setDetailModel] = useState({
    location: {
      lat: 100,
      lng: 200,
    },
    size: null,
  });
  const [sizeDetail, setSizeDetail] = useState(null);
  const SnakeSelectedImage = useRef(null);
  const FileInput = useRef(null);

  const uploadHandler = (event) => {
    const fileInput = event.target;
    if (fileInput.files.length > 0) {
      var selectedFile = fileInput.files[0];
      if (selectedFile.size < 2000000) {
        setUploadState("afterUpload");
        setUploadDetailsModal(true);
        var reader = new FileReader();
        reader.onload = function (event) {
          SnakeSelectedImage.current.src = event.target.result;
          setSnakeFace(event.target.result);
        };
        reader.readAsDataURL(selectedFile);
      } else {
        toast.warn("The selected photo is larger than the specified size");
        fileInput.value = null;
      }
    }
  };

  const resetHandler = () => {
    FileInput.current.value = null;
    setUploadState("beforeUpload");
    setHasInformation(false);
    setSizeDetail(null);
    setDetailModel({
      location: {
        lat: 100,
        lng: 200,
      },
      size: null,
    });
  };

  const submitDetailHandler = () => {
    setHasInformation(true);
    setSizeDetail(detailModel.size && detailModel.size);
    setUploadDetailsModal(false);
  };

  return (
    <>
      <div className="upload__image__step">
        <div className="image__identification__uploader">
          <div className="head__text">
            <h2>Snake image Identification</h2>
            {uploadSate === "afterUpload" && (
              <h5>it easy , Just upload and see the result</h5>
            )}
          </div>
          <div
            className="upload__box"
            style={{
              border: uploadSate === "afterUpload" && "none",
            }}
          >
            <h4>Drag and Drop or Select a file for Scan</h4>
            <input
              type="file"
              name=""
              id=""
              accept="image/png, image/jpg, image/jpeg"
              ref={FileInput}
              onChange={(event) => uploadHandler(event)}
            />
            <SnakePlusIcon className="snake__plus__icon" />
            {uploadSate === "afterUpload" && (
              <ViewHeightFull>
                <div className="after__upload">
                  <img src="" alt="" ref={SnakeSelectedImage} />
                  {hasInformation && (
                    <>
                      <div className="image__overlay"></div>
                      <div className="information">
                        {detailModel && detailModel.location && (
                          <div className="location">
                            <span>Lng: {detailModel.location.lng}</span>
                            <span>Lat: {detailModel.location.lat}</span>
                          </div>
                        )}
                        <div className="size">
                          {sizeDetail && <span>Size: {sizeDetail}</span>}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </ViewHeightFull>
            )}
          </div>
          {uploadSate === "afterUpload" && (
            <div className="upload__actions">
              <div className="two__button">
                {hasInformation && (
                  <button
                    className="orange__button"
                    onClick={() => setUploadDetailsModal(true)}
                  >
                    Change Detail
                  </button>
                )}
                {!hasInformation && (
                  <button
                    className="orange__button"
                    onClick={() => setUploadDetailsModal(true)}
                  >
                    Add Detail
                  </button>
                )}
                <button className="blue__button" onClick={() => resetHandler()}>
                  Reset
                </button>
              </div>
              <button
                className="green__button"
                onClick={() => props.changeStep(2)}
              >
                Upload and Identify
              </button>
            </div>
          )}
          {uploadSate === "beforeUpload" && (
            <div className="upload__hints">
              <div className="items">
                <div className="item">
                  <span>Permitted formats include: Png , jpg , jpeg</span>
                </div>
                <div className="item">
                  <span>File size can not be more than 2 MB</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {uploadSate === "beforeUpload" && (
          <div className="to__know">
            <div className="items">
              <div className="item">
                <div className="picture">
                  <img src={SnakeOne} alt="" />
                </div>
                <span className="text">
                  Photo of the back surface and not from the side
                </span>
              </div>
              <div className="item">
                <div className="picture">
                  <img src={SnakeTwo} alt="" />
                </div>
                <span className="text">
                  At least 50% of the snake's body is seen
                </span>
              </div>
              <div className="item">
                <div className="picture">
                  <img src={SnakeThree} alt="" />
                </div>
                <span className="text">
                  The snake should be clear in the picture and not clouded
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={uploadDetailsModal}
        onHide={() => setUploadDetailsModal(false)}
      >
        <div className="home__modal">
          <div className="modal__header">
            <h6>Add more information for a more detailed search</h6>
            <div
              className="close__modal"
              onClick={() => setUploadDetailsModal(false)}
            >
              <CloseModalIcon />
            </div>
          </div>
          <div className="modal__content pt-0">
            <div className="items">
              <div className="item mb-5" style={{ cursor: "pointer" }}>
                <div
                  className="title d-flex justify-content-between align-items-center"
                  onClick={() => setLocationCollapse((prevState) => !prevState)}
                >
                  <h6 className="mb-0">Location</h6>
                  <ArrowDown />
                </div>
                <hr />
                <Collapse in={locationCollapse}>
                  <div
                    className="location"
                    style={{
                      width: "100%",
                      height: "247px",
                    }}
                  >
                    <CustomGoogleMap
                      snakeFace={snakeFace}
                      userLocation={userLocation}
                      setUserLocation={setUserLocation}
                    />
                    {/* <iframe
                      src="https://maps.google.com/maps?width=507&amp;height=274&amp;hl=en&amp;q=University of Oxford&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                      width="600"
                      height="450"
                      frameBorder="0"
                      style={{ border: 0, width: "100%", height: "100%" }}
                      allowFullScreen=""
                      aria-hidden="false"
                      tabIndex="0"
                    ></iframe> */}
                  </div>
                </Collapse>
              </div>
              <div className="item" style={{ cursor: "pointer" }}>
                <div
                  className="title d-flex justify-content-between align-items-center"
                  onClick={() => setSizeCollapse((prevState) => !prevState)}
                >
                  <h6 className="mb-0">Size</h6>
                  <ArrowDown />
                </div>
                <hr />
                <Collapse in={sizeCollapse}>
                  <div className="content">
                    <div className="items d-flex">
                      <div
                        className="item d-flex align-items-center mr4"
                        style={{
                          marginRight: "39px",
                        }}
                        onChange={() =>
                          setDetailModel({
                            ...detailModel,
                            size: "Below one meter",
                          })
                        }
                      >
                        <input
                          type="radio"
                          name="input-check"
                          id="below-one"
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "7px",
                          }}
                          defaultChecked={
                            sizeDetail && sizeDetail === "Below one meter"
                          }
                        />
                        <label htmlFor="below-one">Below one meter</label>
                      </div>
                      <div
                        className="item d-flex align-items-center"
                        onChange={() =>
                          setDetailModel({
                            ...detailModel,
                            size: "More than one meter",
                          })
                        }
                      >
                        <input
                          type="radio"
                          name="input-check"
                          id="more-than"
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "7px",
                          }}
                          defaultChecked={
                            sizeDetail && sizeDetail === "More than one meter"
                          }
                        />
                        <label htmlFor="more-than">More than one meter</label>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <button
              type="submit"
              className="submit"
              onClick={() => submitDetailHandler()}
            >
              Submit
            </button>
            <button
              className="return"
              onClick={() => setUploadDetailsModal(false)}
            >
              Skip
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default UploadImageStep;
